<template>
  <div id="app" :style="appStyle">
    <emp-base-layout>
      <template v-slot:header>
        <emp-nav-header></emp-nav-header>
      </template>
      <router-view/>
    </emp-base-layout>
  </div>
</template>

<script>
import { isApp } from "@/utils/common";
export default {
  name: "App",
  data() {
    return {
      height: 0
    }
  },
  computed: {
    appStyle() {
      const { height } = this;
      if(!height) return {};
      else return { height: `${height}px` };
    }
  },
  mounted() {
    /* document.body.addEventListener('touchmove', function (e) {
        e.preventDefault() // 阻止默认的处理方式(阻止下拉滑动的效果)
    }, {paempive: false}); */
    const u = navigator.userAgent;
    const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    let isReset = false;
    if (isiOS) {
      document.body.addEventListener("focusin", () => {
        //软键盘弹出的事件处理
        isReset = false;
      });
      document.body.addEventListener("focusout", () => {
        //软键盘收起的事件处理
        isReset = true;
        setTimeout(() => {
          //当焦点在弹出层的输入框之间切换时先不归位
          if (isReset) {
            window.scroll(0, 0); //失焦后强制让页面归位
          }
        }, 0);
      });
    } else if (isAndroid) {
      window.onresize = () => {
        if (
          document.activeElement.tagName === "INPUT" ||
          document.activeElement.tagName === "TEXTAREA"
        ) {
          setTimeout(() => {
            document.activeElement.scrollIntoViewIfNeeded();
          }, 0);
        }
      };
    }
    if(isAndroid && isApp()) {
      this.height = document.body.clientHeight + 3;
    } else {
      this.height = document.body.clientHeight;
    }
  }
};
</script>

<style lang="less" scoped>
@import "./style/constant.less";

#app {
  font-family: @font-family-default;
  font-size: @font-md-size;
  font-weight: @font-weight-normal;
  position: relative;
}
</style>
